<template>
  <header class="site-header">
    <nav class="navbar navbar-expand-lg">
      <div class="container-fluid">
        <a class="navbar-brand" href="/">
          <SiteLogo />
          <div class="d-flex flex-column flex-sm-row column-gap-2">
            <span class="navbar-brand-org">GridUnity</span>
            <span class="navbar-brand-site text-brand">Interconnection Portal</span>
          </div>
        </a>
        <EnvBadge />

        <SiteNavigation />
      </div>
    </nav>
  </header>
</template>

<script setup>
import EnvBadge from '@shared/components/EnvBadge.vue'
import SiteNavigation from '@shared/components/SiteNavigation.vue'
import SiteLogo from './SiteLogo.vue'
</script>
